(function (Drupal, drupalSettings) {
  Drupal.behaviors.databg = {
    attach: function (context, settings) {
      const elements = context.querySelectorAll("*[data-bg]");
      elements.forEach((el) => {
        if (!el.dataset.bgProcessed) {
          el.dataset.bgProcessed = "true";
          const bg = el.getAttribute("data-bg");
          if (bg.startsWith("#")) {
            el.style.backgroundColor = bg;
          } else {
            el.style.backgroundImage = `url(${bg})`;
          }
        }
      });
    },
  };
})(Drupal, drupalSettings);
